import React, { useState, useEffect, useRef, useCallback } from "react";
import { Document, Page } from "react-pdf";
import { pdfjs } from 'react-pdf';
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
// pdfjs.GlobalWorkerOptions.workerSrc = "./js/pdf.worker.js";

import { createUseGesture, dragAction, pinchAction } from "@use-gesture/react";
import { useSpring, animated } from "@react-spring/web";
import {Spinner } from 'react-bootstrap';
import styles from './stylepdf.module.css'

const useGesture = createUseGesture([pinchAction]);
export default function AllPages(props) {
  let [scales, setScales] = useState (1)
  const MOBILE_WIDTH = 576;

  useEffect(() => {
    window.addEventListener('resize', resize);
    resize()
    const handler = (e) => e.preventDefault();
    document.addEventListener("gesturestart", handler);
    document.addEventListener("gesturechange", handler);
    document.addEventListener("gestureend", handler);
    return () => {
      document.removeEventListener("gesturestart", handler);
      document.removeEventListener("gesturechange", handler);
      document.removeEventListener("gestureend", handler);
      window.removeEventListener('resize', resize);
    };
  }, []);
  const [numPages, setNumPages] = useState(null);
  const ref = useRef();
  // const [scaleV, setScaleV] = useState(1);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  const [style, api] = useSpring(() => ({
    x: 0,
    y: 0,
    scale: scales,
    rotateZ: 0
  }));

  const resize = () => {
    if (window.innerWidth <= MOBILE_WIDTH) {
      setScales(0.75);
    }
    // else if (window.innerWidth >= MOBILE_WIDTH) {
    //   setScales(1.5);
    // }
  }

  const zoomIn = () => {
    let a = scales + (0.25)
    setScales(a)
    console.log(a)
  };

  const zoomOut = () => {
    console.log()
     let a = scales - (0.25)
     setScales(a)
     console.log(a)
  };
  // useGesture(
  //   {
  //     onPinch: ({
  //       origin: [ox, oy],
  //       first,
  //       movement: [ms],
  //       offset: [s, a],
  //       memo
  //     }) => {
  //       if (first) {
  //         const { width, height, x, y } = ref.current.getBoundingClientRect();
  //         const tx = ox - (x + width / 2);
  //         const ty = oy - (y + height / 2);
  //         memo = [style.x.get(), style.y.get(), tx, ty];
  //       }
  //       setScaleV(s);
  //       const x = memo[0] - ms * memo[2];
  //       const y = memo[1] - ms * memo[3];
  //       api.start({ scale: s * 1.2, a });
  //       ref.current.scrollTop = 10;
  //       return memo;
  //     }
  //   },
  //   {
  //     target: ref,
  //     pinch: {
  //       scaleBounds: { min: 0.1, max: 5 },
  //       rubberband: true,
  //       preventScroll: true
  //     }
  //   }
  // );
  const { pdf } = props;
  return (
    <>
    <div>
      <Document
        file={pdf} 
        loading={<div style={{alignItems: 'center', textAlign:'center'}}><Spinner animation="border" variant="secondary"/></div>}
        // options={{ workerSrc: "../../component/pdf.worker.js" }}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page className={styles.contentpdf} key={`page_${index + 1}`} pageNumber={index + 1} scale={scales}/>
        ))}

      </Document>
    </div>
    <div className={styles.containerzoom}>
      <button className={styles.buttonFloatingUp} onClick={()=>zoomIn()}><img src="images/zoom-in.png" width="20" /></button>
      <button
        disabled={scales <= 0} 
        className={styles.buttonFloatingUp} 
        style={{marginTop:10}} 
        onClick={()=>zoomOut()}><img src="images/zoom-out.png" width="20" /></button>
    </div>
    </>
  );
}
